module.exports = __webpack_public_path__ + "static/design-thinking-process-poster-cec0434313158a6bdcb0e2673d139266.jpg";